import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

import { SERVER_URL } from 'config/server.config'
import token from 'lib/jwt.class'

export const request = async (
  config: AxiosRequestConfig,
): Promise<AxiosResponse> => {
  const jwt: string | null = await token.read()

  const headers = {}
  if (jwt) Object.assign(headers, { Authorization: jwt })

  return axios({
    baseURL: SERVER_URL,
    timeout: 7000,
    headers,
    validateStatus: (status: number) => status >= 200 && status < 300,
    ...config,
  })
}
